import React from 'react';
import { useI18n } from '@wordpress/react-i18n';
import { pathElectrified } from '../route-calculator';
import { ROUTE_COLORS } from '../constants';
import { formatNumber } from '../utils';
export function RouteInfoAndAlternatives({ routePath, routeCache, routeStops, routeMileage, selectedRouteIndex, alternativeRoutes, showAlternativeRoutes, onShowAlternativeRoutesChange, isCalculatingAlternatives, onComputeAlternatives, onSelectRoute, maxRoutesCount: MAX_ROUTES_COUNT }) {
    const { __ } = useI18n();
    const electrifiedLabel = (status) => ({
        partial: __('Dalinai', 'ltg-widgets'),
        yes: __('Taip', 'ltg-widgets'),
        no: __('Ne', 'ltg-widgets'),
        unknown: __('Nežinoma', 'ltg-widgets'),
    }[status]);
    if (!routePath || !routeCache || routePath.length === 0) {
        return null;
    }
    const displayStops = selectedRouteIndex !== null && alternativeRoutes[selectedRouteIndex]
        ? alternativeRoutes[selectedRouteIndex].stops
        : routeStops;
    const displayDistance = selectedRouteIndex !== null && alternativeRoutes[selectedRouteIndex]
        ? alternativeRoutes[selectedRouteIndex].distance
        : routeMileage;
    const displayElectrified = selectedRouteIndex !== null && alternativeRoutes[selectedRouteIndex]
        ? alternativeRoutes[selectedRouteIndex].electrified
        : pathElectrified(routePath, routeCache.edgeMeta);
    return (React.createElement("div", { style: { fontSize: '14px', marginBottom: '35px' } },
        React.createElement("div", { style: { marginBottom: '15px' } },
            React.createElement("div", { style: { fontWeight: 600, marginBottom: '8px' } }, __('Pasirinktas maršrutas', 'ltg-widgets')),
            React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '12px 24px', alignItems: 'baseline' } },
                React.createElement("div", { className: "green-border", style: { width: '100%' } },
                    React.createElement("strong", null,
                        __('Stotys', 'ltg-widgets'),
                        ":"),
                    ' ',
                    displayStops.join(' → ')),
                React.createElement("span", null,
                    React.createElement("strong", null,
                        __('Atstumas', 'ltg-widgets'),
                        ":"),
                    ' ',
                    formatNumber(displayDistance, 2),
                    " ",
                    __('km', 'ltg-widgets')),
                React.createElement("span", null,
                    React.createElement("strong", null,
                        __('Elektrifikuotas', 'ltg-widgets'),
                        ":"),
                    ' ',
                    electrifiedLabel(displayElectrified)))),
        React.createElement("div", { style: {
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                flexWrap: 'wrap',
                marginBottom: '20px'
            } },
            alternativeRoutes.length === 0 ? (React.createElement("button", { onClick: onComputeAlternatives, disabled: isCalculatingAlternatives, className: "btn" }, isCalculatingAlternatives ? __('Skaičiuojama...', 'ltg-widgets') : __('Rasti alternatyvius maršrutus', 'ltg-widgets'))) : (React.createElement("button", { onClick: () => onShowAlternativeRoutesChange(!showAlternativeRoutes), className: "btn" }, showAlternativeRoutes ? __('Slėpti alternatyvius maršrutus', 'ltg-widgets') : __('Rodyti alternatyvius maršrutus', 'ltg-widgets'))),
            isCalculatingAlternatives && (React.createElement("span", { style: { fontSize: '13px', color: '#777' } },
                __('Skaičiuojamos alternatyvos...', 'ltg-widgets'),
                " (",
                alternativeRoutes.length,
                ")"))),
        alternativeRoutes.length > 0 && showAlternativeRoutes && (React.createElement("div", { style: { marginBottom: '30px' } },
            React.createElement("div", { className: "ltg-control-label", style: { margin: '18px 0 10px' } },
                __('Visi maršrutai', 'ltg-widgets'),
                ' ',
                React.createElement("span", { style: {
                        background: '#eee',
                        borderRadius: '999px',
                        padding: '2px 10px',
                        fontSize: '12px'
                    } }, alternativeRoutes.length)),
            React.createElement("div", { style: {
                    overflow: 'auto',
                    border: '1px solid #eee',
                    borderRadius: '10px',
                    background: '#fff'
                } },
                React.createElement("table", { style: { borderCollapse: 'collapse', width: '100%', minWidth: '780px' } },
                    React.createElement("thead", null,
                        React.createElement("tr", { style: { background: '#fafafa', borderBottom: '1px solid #eee' } },
                            React.createElement("th", { style: { textAlign: 'right', padding: '10px' } }, "#"),
                            React.createElement("th", { style: { textAlign: 'left', padding: '10px' } }, __('Stotys', 'ltg-widgets')),
                            React.createElement("th", { style: { textAlign: 'left', padding: '10px' } }, __('Atstumas', 'ltg-widgets')),
                            React.createElement("th", { style: { textAlign: 'left', padding: '10px' } }, __('Elektrifikuotas', 'ltg-widgets')))),
                    React.createElement("tbody", null, alternativeRoutes.map((route, idx) => {
                        const colorIdx = idx % ROUTE_COLORS.length;
                        const routeColor = ROUTE_COLORS[colorIdx];
                        const isSelected = selectedRouteIndex === idx;
                        return (React.createElement("tr", { key: idx, onClick: () => {
                                onSelectRoute(idx);
                                onShowAlternativeRoutesChange(true);
                            }, style: {
                                cursor: 'pointer',
                                transition: 'background 0.2s',
                                background: isSelected ? '#e3f2fd' : 'white'
                            }, onMouseOver: (e) => {
                                if (!isSelected)
                                    e.currentTarget.style.background = '#f5f5f5';
                            }, onMouseOut: (e) => {
                                if (!isSelected)
                                    e.currentTarget.style.background = 'white';
                            } },
                            React.createElement("td", { style: {
                                    width: '40px',
                                    textAlign: 'right',
                                    padding: '8px 10px',
                                    verticalAlign: 'top'
                                } },
                                React.createElement("span", { style: {
                                        display: 'inline-block',
                                        width: '4px',
                                        height: '20px',
                                        background: routeColor,
                                        marginRight: '6px'
                                    } }),
                                idx + 1),
                            React.createElement("td", { style: {
                                    padding: '8px 10px',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                } }, route.stops.join(' → ')),
                            React.createElement("td", { style: { width: '120px', padding: '8px 10px', verticalAlign: 'top' } },
                                formatNumber(route.distance, 2),
                                " ",
                                __('km', 'ltg-widgets')),
                            React.createElement("td", { style: { width: '110px', padding: '8px 10px', verticalAlign: 'top' } }, electrifiedLabel(route.electrified))));
                    }))))))));
}
